export { DesignSystemProvider, useDesignSystem, } from './components/DesignSystemProvider';
export { ZinniaProvider } from './components/ZinniaProvider/ZinniaProvider';
//# sourceMappingURL=index.js.map
// @zapier/design-system-context@1.5.0 (2376bbd83)
